import React, { useState, useEffect } from 'react';
import { Message, Button, Stack } from 'rsuite';
import WarningIcon from '@rsuite/icons/legacy/Warning';

const WARNING_STORAGE_KEY = 'account_recreation_warning_shown_at';
const WARNING_DISMISSED_KEY = 'account_recreation_warning_dismissed';
const WARNING_DISPLAY_DAYS = 7;

const AccountRecreationWarning = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDismissed = localStorage.getItem(WARNING_DISMISSED_KEY);
    if (isDismissed) {
      setIsVisible(false);
      return;
    }

    const storedTime = localStorage.getItem(WARNING_STORAGE_KEY);

    if (!storedTime) {
      // First time seeing the warning, show it and store the timestamp
      setIsVisible(true);
      localStorage.setItem(WARNING_STORAGE_KEY, new Date().getTime().toString());
    } else {
      // Check if warning period (7 days) has elapsed
      const shownAtMs = parseInt(storedTime, 10);
      const elapsedMs = new Date().getTime() - shownAtMs;
      const elapsedDays = elapsedMs / (1000 * 60 * 60 * 24);

      if (elapsedDays < WARNING_DISPLAY_DAYS) {
        setIsVisible(true);
      } else {
        // Warning period has expired, hide it
        setIsVisible(false);
      }
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(WARNING_DISMISSED_KEY, 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div style={{ padding: '12px 24px', backgroundColor: '#fff2e6' }}>
      <Message
        showIcon
        full
        closable={false}
        type="warning"
        icon={<WarningIcon />}
        style={{
          marginBottom: 0,
          backgroundColor: 'transparent',
          border: 'none',
          padding: 0,
        }}
      >
        <Stack spacing={16} style={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ flex: 1 }}>
            <strong>Account Recreation Required</strong>
            <p style={{ margin: '4px 0 0 0', fontSize: '14px' }}>
              Due to a recent database incident, you'll need to create a new account to access your collections. Your old data has been securely archived. We apologize for the inconvenience.
            </p>
          </div>
          <Button size="sm" onClick={handleDismiss} style={{ flexShrink: 0 }}>
            Dismiss
          </Button>
        </Stack>
      </Message>
    </div>
  );
};

export default AccountRecreationWarning;
